module.exports = "/_next/static/images/truck2-9961acd37da39bac66faa4c1522c01d8.png.webp";